// extracted by mini-css-extract-plugin
export var deleteIcon = "_nv-5";
export var deleteOption = "_nv-3";
export var divider = "_nv-2";
export var downloadIcon = "_nv-4";
export var drawer = "_nv-0";
export var drawerFooter = "_nv-6";
export var drawerOpen = "_nv-1";
export var highlighted = "_nv-7";
export var lighterHighlight = "_nv-8";